<template>
  <div :class="{ active: allActive, contentt: contentActive, form: formActive }" class="action-card">
    <div class="top">
      <i class="mdi mdi-close exit cursor-pointer" @click="turnFormActive"></i>
      <div class="title">
        {{ title }}
      </div>
      <div class="buttons" :class="{ form: add }">
        <i v-if="add" class="add mdi mdi-plus-circle-outline" @click="turnFormActive"> </i>
        <i class="arrow mdi mdi-chevron-down" @click="turnAllActive"> </i>
      </div>
    </div>
    <div class="all" :style="'height :' + allActiveHeight">
      <div class="contentt" :style="'height :' + contentActiveHeight + 'px'">
        <slot name="content" />
      </div>
      <div class="form" :style="'height :' + formActiveHeight">
        <slot name="form" />
      </div>
      <div v-if="btns && formActive && !$slots.footer" class="form-buttons">
        <h-b-action text="Annuler" :positive="false" color="primary" @click.native="emitCancelFunction"> </h-b-action>
        <h-b-action
          v-if="loadedPost"
          text="Valider"
          :positive="true"
          color="primary"
          @click.native="emitSubmitFunction"
        >
        </h-b-action>
        <h-e-spinner v-else size="sm" class="m-0 p-0 d-flex justify-content-end"></h-e-spinner>
      </div>
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
import HBAction from '../buttons/action'

export default {
  name: 'action',

  components: {
    HBAction,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    add: {
      type: Boolean,
      default: true,
    },
    height: {
      type: Number,
      default: 200,
    },
    btns: {
      type: Boolean,
      default: true,
    },
    loadedPost: {
      type: Boolean,
      default: true,
    },
    
    outside: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      contentActive: true,
      formActive: false,
      allActive: true,
      allActiveHeight: `${this.height}px`,
      contentActiveHeight: this.height - 20,
      formActiveHeight: 0,
    }
  },

  watch: {
    allActive() {
      if (this.allActive) {
        this.allActiveHeight = `${this.height}px`
      } else if (!this.allActive) {
        this.allActiveHeight = '0px'
      }
      if (this.allActive && this.formActive) {
        this.allActiveHeight = 'auto'
      }
    },

    contentActive() {
      if (this.contentActive) {
        this.contentActiveHeight = this.height - 20
      } else {
        this.contentActiveHeight = 0
      }
    },

    formActive() {
      if (this.formActive) {
        this.formActiveHeight = 'auto'
      } else {
        this.formActiveHeight = '0px'
      }
      if (this.allActive && this.formActive) {
        this.allActiveHeight = 'auto'
      }
    },
  },

  mounted() {},

  methods: {
    turnFormActive() {
      if(this.outside) {
        this.$emit('create')
        return 
      }
      if (!this.formActive) {
        this.formActive = true
        this.contentActive = false
      } else {
        this.formActive = false
        this.contentActive = true
      }
      this.$emit('formChange', this.formActive)
    },

    emitCancelFunction() {
      this.$emit('clickCancel')
    },

    emitSubmitFunction() {
      this.$emit('clickSubmit')
    },

    manageFormClose() {
      this.formActive = false
      this.contentActive = true
    },

    manageFormOpen() {
      this.formActive = true
      this.contentActive = false
    },

    turnAllActive() {
      this.allActive = !this.allActive
    },
  },
}
</script>

<style scoped></style>
